// Category normalisation: legacy market data has a mix of English
// (Sports, Politics) and German (Wirtschaft, Politik, …) labels for
// the same conceptual buckets. Without a mapping the markets list
// renders two buttons that each return a different subset.
//
// One source of truth here: `ALIAS_TO_CANONICAL` collapses every
// known variant onto a German canonical key. `displayCategory`
// returns the user-facing label. Anything we don't know about
// passes through untouched (lower-cased) so unexpected categories
// still work without crashing the filter UI.

const ALIAS_TO_CANONICAL = {
  // Politics
  politics: 'politik',
  politik: 'politik',
  // Sports
  sports: 'sport',
  sport: 'sport',
  // Economy
  economy: 'wirtschaft',
  economics: 'wirtschaft',
  wirtschaft: 'wirtschaft',
  finance: 'wirtschaft',
  // Society
  society: 'gesellschaft',
  social: 'gesellschaft',
  gesellschaft: 'gesellschaft',
  // Environment
  environment: 'umwelt',
  climate: 'umwelt',
  umwelt: 'umwelt',
  // Tech
  technology: 'technologie',
  tech: 'technologie',
  technologie: 'technologie',
  // Internal test buckets — keep as-is, they're not user-facing.
  test: 'test',
};

const CANONICAL_TO_LABEL = {
  politik: 'Politik',
  sport: 'Sport',
  wirtschaft: 'Wirtschaft',
  gesellschaft: 'Gesellschaft',
  umwelt: 'Umwelt',
  technologie: 'Technologie',
  test: 'test',
};

/** Lowercase canonical key for a category. Same input → same output regardless of casing or language. */
export const canonicalCategory = (raw) => {
  if (!raw) return '';
  const lower = String(raw).toLowerCase().trim();
  return ALIAS_TO_CANONICAL[lower] || lower;
};

/** User-facing label for a (possibly aliased) category. */
export const displayCategory = (raw) => {
  const key = canonicalCategory(raw);
  if (CANONICAL_TO_LABEL[key]) return CANONICAL_TO_LABEL[key];
  // Unknown category: present it title-cased.
  if (!key) return '';
  return key.charAt(0).toUpperCase() + key.slice(1);
};

/** Two categories are equivalent if their canonical keys match. */
export const sameCategory = (a, b) => canonicalCategory(a) === canonicalCategory(b);
